import { NgIf,NgClass } from '@angular/common';
import { Component, Input, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { OAService } from '../../../services/oa.service';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-oa-installed-save',
    imports: [TableModule, DropdownModule, FormsModule, NgIf, NgClass, DatePipe],
    templateUrl: './oa-installed-save.component.html',
    styleUrl: './oa-installed-save.component.scss'
})
export class OaInstalledSaveComponent {
  loading: boolean = false;
  installedData: any[] = [];
  dropDownData: any[] = [];
  selectedDivision: any = '';
  @Input() OaRemovedData: any;

  constructor(private oaService: OAService,private router: Router){

  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['OaRemovedData']) {
      if (this.OaRemovedData) {
        this.processOAData();
      }
    }
  }

  processOAData(){
    this.installedData = this.OaRemovedData.tblOAAssignedToMe_Installed;
    this.installedData.map((item: any) => {
      if (item.tlr_status === 'I') {
        item.status = 'Installed';
        item.cssClass = 'green'
      } else if (item.tlr_status === 'P') {
        item.status = 'Pre Installation';
        item.cssClass = 'blue'
      } else if (item.tlr_status === 'R') {
        item.status = 'Removed';
        item.cssClass = 'red'
      }
    });

  }

  details(row :any){
    this.router.navigate(['/details-section', row.tag_number]);
  }

  editComplianceDetails(row : any){
    localStorage.setItem('oA_action_type', 'Update');

      this.router.navigate(['/oa-compliance-details-section', row.tag_number]);
  
  }
}
